import { Tooltip } from "components";
import { disabledDate, schoolGrades, validatePhoneNumber } from "utils";
import { regionalUnities } from "utils/regional_unities";
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';

export const formFields2 = [
    
  {
    label: (
      <span>
        <span>
          Επιλέξτε τη βαθμίδα σχολείου για την οποία υποβάλετε Αίτηση Χρηματοδότησης
        </span>
        <span className="color-red"> *</span>
        <Tooltip
        placement="right"
        className="iban-info"
        title={
          <span className="iban-info-title left-align-text">
            <p>Σε περίπτωση συστέγασης νηπιαγωγείου με Δημοτικό Σχολείο σε ένα ενιαίο κτίριο,  για το <br/> εν λόγω επενδυτικό σχέδιο θα ισχύουν τα όρια επιδότησης που αφορούν τα Δημοτικά.</p>
           <p> Σε περίπτωση συστέγασης Παιδικού Σταθμού και Νηπιαγωγείου, αίτηση ένταξης στο <br/> Πρόγραμμα δύναται να υποβάλει μόνο το Νηπιαγωγείο. </p>
            Σε περίπτωση συστέγασης Παιδικού Σταθμού και Νηπιαγωγείου, αίτηση ένταξης στο <br/> Πρόγραμμα δύναται να υποβάλει μόνο ο Παιδικός Σταθμός. <br/> 
          </span>
        }
      >
        <Info className="infoIconSmallIban" />
      </Tooltip>
      </span>
    ),
    type: 'select',
    id: 'schoolGrade',
    title: 'Βαθμίδα Σχολείου',
    options: schoolGrades,
    // allowClear:true,
    // showSearch:true,
    name: 'schoolGrade',
    size: 'small',
    placeholder: 'Επιλέξτε Βαθμίδα',
    span: 24,
    rules: [
      { required: false, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    // asterisk: true,
    
  },
  {
    label: 'Υπάρχει Συστέγαση;',
    id: 'coHousing',
    type: 'radio',
    className: 'like-text',
    name: 'coHousing',
    size: 'small',
    defaultValue: false,
    span: 24,
    options:[
      { label: 'Ναι', id:'coHousingYes',value: true },
      { label: 'Όχι', id:'coHousingNo', value: false }
    ],
    defaultValue: true,
    asterisk: true,
  },
  
]

export const formFieldsCo = [

{
  label: (
    <span>
      <span>
        Επιλέξτε τη βαθμίδα σχολείου για την οποία υποβάλετε Αίτηση Χρηματοδότησης
      </span>
      <span className="color-red"> *</span>
    </span>
  ),
  type: 'select',
  id: 'schoolGradeCo',
  title: 'Βαθμίδα Σχολείου',
  options: schoolGrades,
  allowClear:true,
  // showSearch:true,
  name: 'schoolGradeCo',
  size: 'small',
  placeholder: 'Επιλέξτε Βαθμίδα',
  span: 24,
  rules: [
    { required: false, message: 'Το πεδίο είναι υποχρεωτικό' },
    { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
  ],
  // asterisk: true,
  
},
{ //TODO pending to be 'required' and maybe with multiple values
  label: 'Χαρακτηριστικό Όνομα Συστεγασμένου',
  id: 'coHousingName',
  type: 'text',
  name: 'coHousingName',
  size: 'large',
  placeholder: 'Εισάγετε Όνομα',
  span: 24,
  rules: [
    { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
  ],
  asterisk: true,
},

]
export const formFields = [
  {
    label: 'Χαρακτηριστικό Όνομα',
    id: 'buildName',
    type: 'text',
    name: 'buildName',
    size: 'large',
    placeholder: 'Εισάγετε Χαρακτηριστικό Όνομα',
    span: 24,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
    asterisk: true,
    
  },
  {
    label: 'Πολεοδομική Χρήση',
    id: 'buildUsage',
    type: 'text',
    name: 'buildUsage',
    size: 'large',
    placeholder: 'Εισάγετε Πολεοδομική Χρήση',
    span: 24,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
    asterisk: true,
   
  },
  {
    label: 'Έτος Κατασκευής',
    id: 'buildYear',
    type: 'number',
    name: 'buildYear',
    size: 'large',
    maxLength: 4,
    placeholder: 'Εισάγετε Έτος Κατασκευής',
    span: 24,
    simple: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
    asterisk: true,
   
  },

    {
      label: 'Οδός - Αριθμός',
      id: 'buildStreet',
      type: 'text',
      name: 'buildStreet',
      size: 'large',
      placeholder: 'Εισάγετε Οδό - Αριθμό',
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
      ],
      
      asterisk: true,
    },
    {
      label: 'Τ.Κ.',
      id: 'buildTk',
      type: 'number',
      simple: true,
      name: 'buildTk',
      size: 'large',
      placeholder: 'Εισάγετε Τ.Κ.',
      maxLength: 5,
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        () => ({
          validator(_, value) {
            return value && String(value).length !== 5 ? Promise.reject('Το πεδίο πρέπει να έχει ακριβώς 5 ψηφία') : Promise.resolve();
          },}),
      ],
      
      asterisk: true,
    },
    {
      label: 'Νομός ',
      type: 'select',
      id: 'buildPerfecture',
      title: 'Νομός',
      // options: regionalUnities,
      allowClear:true,
      showSearch:true,
      name: 'buildPerfecture',
      size: 'true',
      placeholder: 'Εισάγετε Νομό',
      span: 12,
      rules: [
        { required: false, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
      ],
      asterisk: true,
      
    },
    {
      label: 'Περιοχή',
      id: 'buildDistrict',
      title: 'Περιοχή',
      type: 'select',
      size: 'default',
      name: 'buildDistrict',
      placeholder: 'Επιλέξτε Περιοχή',
      // options: [({getFieldValue}) => {
      //   const prevValue = getFieldValue('abiPerfecture')[0].children;
      //   console.log("prevValue:", prevValue)
      //   return regionalUnitiesWithMunicipalities.filter((word) => word.value === prevValue )}],
      span: 12,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
      // ],
      
      asterisk: true,
    },
  
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Αρ. Παροχής Ρεύματος',
      id: 'powerSupNo',
      type: 'text',
      name: 'powerSupNo',
      size: 'large',
      placeholder: 'Εισάγετε Αρ. Παροχής',
      span: 24,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      ],
      asterisk: true,
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Ωφέλιμη Επιφάνεια',
      id: 'usableArea',
      type: 'text',
      name: 'usableArea',
      size: 'large',
      placeholder: 'Εισάγετε Ωφέλιμη Επιφάνεια (τ.μ.)',
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      ],
      asterisk: true,
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Συνολική Επιφάνεια',
      id: 'totalArea',
      type: 'text',
      name: 'totalArea',
      size: 'large',
      placeholder: 'Εισάγετε Συνολική Επιφάνεια (τ.μ.)',
      span: 12,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      ],
      asterisk: true,
    },
]

  export const formFields1 = 
  [
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Εφαρμογή συστήματος θερμομόνωσης σε αδιαφανή στοιχεία του κελύφους',
      title: 'Εφαρμογή συστήματος θερμομόνωσης σε αδιαφανή στοιχεία του κελύφους',
      id: 'thermIns',
      type: 'checkbox',
      name: 'thermIns',
      size: 'large',
      placeholder: '',
      span: 24,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Ποσό Χωρίς ΦΠΑ',
      id: 'amountThermIns',
      type: 'formattedNumber',
      name: 'amountThermIns',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      rules: [
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (value !== '0,00') {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Το Ποσό Χωρίς ΦΠΑ δεν μπορεί να είναι 0'));
          },
        }),
      ]
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'ΦΠΑ',
      id: 'amountThermInsFpa',
      type: 'formattedNumber',
      name: 'amountThermInsFpa',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Αντικατάσταση διαφανών στοιχείων (κουφωμάτων) του κελύφους',
      id: 'shellReplace',
      type: 'checkbox',
      name: 'shellReplace',
      size: 'large',
      placeholder: '',
      span: 24,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Ποσό Χωρίς ΦΠΑ',
      id: 'amountShellReplace',
      type: 'formattedNumber',
      name: 'amountShellReplace',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      rules: [
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (value !== '0,00') {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Το Ποσό Χωρίς ΦΠΑ δεν μπορεί να είναι 0'));
          },
        }),
      ]
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'ΦΠΑ',
      id: 'amountShellReplaceFpa',
      type: 'formattedNumber',
      name: 'amountShellReplaceFpa',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Αναβάθμιση συστήματος θέρμανσης (ή και ψύξης) χώρων',
      id: 'upgradeSys',
      type: 'checkbox',
      name: 'upgradeSys',
      size: 'large',
      placeholder: '',
      span: 24,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Ποσό Χωρίς ΦΠΑ',
      id: 'amountUpgradeSys',
      type: 'formattedNumber',
      name: 'amountUpgradeSys',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      rules: [
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (value !== '0,00') {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Το Ποσό Χωρίς ΦΠΑ δεν μπορεί να είναι 0'));
          },
        }),
      ]
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'ΦΠΑ',
      id: 'amountUpgradeSysFpa',
      type: 'formattedNumber',
      name: 'amountUpgradeSysFpa',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Λοιπές Υπηρεσίες',
      id: 'otherServices',
      type: 'checkbox',
      name: 'otherServices',
      size: 'large',
      placeholder: '',
      span: 24,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Ποσό Χωρίς ΦΠΑ',
      id: 'amountOtherServices',
      type: 'formattedNumber',
      name: 'amountOtherServices',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      rules: [
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (value !== '0,00') {
              return Promise.resolve();
            }
            return Promise.reject(new Error('Το Ποσό Χωρίς ΦΠΑ δεν μπορεί να είναι 0'));
          },
        }),
      ]
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'ΦΠΑ',
      id: 'amountOtherServicesFpa',
      type: 'formattedNumber',
      name: 'amountOtherServicesFpa',
      size: 'large',
      placeholder: 'Εισάγετε Ποσό',
      span: 12,
      maxLength: 10,
      // disabled: true,
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
    },
  ];

  export const formFieldsCost = [
    {
      id: 'totalCost',
      title: 'Συνολικό Κόστος Παρέμβασης χωρίς ΦΠΑ',
      type: 'formattedNumber',
      name: 'totalCost',
      containerClassName: 'formatted-input',
      className: 'right',
      autoFormat : true,
      currency: true,
      size: 'large',
      placeholder: '-',
      span: 12,
      disabled:true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      id: 'totalFpa',
      title: 'Συνολικό ΦΠΑ',
      type: 'formattedNumber',
      name: 'totalFpa',
      containerClassName: 'formatted-input',
      className: 'right',
      autoFormat : true,
      currency: true,
      size: 'large',
      placeholder: '-',
      span: 10,
      disabled:true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      id: 'totalCostWithFpa',
      title: 'Συνολικό Κόστος Παρέμβασης Με ΦΠΑ',
      type: 'formattedNumber',
      name: 'totalCostWithFpa',
      containerClassName: 'formatted-input',
      className: 'right',
      autoFormat : true,
      currency: true,
      size: 'large',
      placeholder: '-',
      span: 10,
      disabled:true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
  ]

  export const formFieldsDeg = [
    { //TODO pending to be 'required' and maybe with multiple values
      label: 'Βαθμοημέρες',
      id: 'degDays',
      type: 'text',
      name: 'degDays',
      size: 'large',
      placeholder: '-',
      span: 24,
      disabled:true
      // rules: [
      //   { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // ],
      // asterisk: true,
    },
  ]


  



